// Languages the assistant can converse in. The `code` is an ISO 639-1 code used
// by the STT (ElevenLabs Scribe), the brain (respond-in-language directive) and
// TTS (ElevenLabs multilingual). Keep this list in sync with the server's
// LANGUAGE_NAMES map in assistantConfig.ts.

export interface AssistantLanguage {
  /** ISO 639-1 code, e.g. "fr". */
  code: string
  /** Native label shown in the picker. */
  label: string
  /** ISO 3166-1 alpha-2 country code for the flag icon (flag-icons `fi fi-xx`). */
  country: string
}

// `country` drives real SVG flags via the flag-icons package — flag emoji don't
// render on Windows, so we use icons instead.
export const SUPPORTED_LANGUAGES: AssistantLanguage[] = [
  { code: 'en', label: 'English', country: 'gb' },
  { code: 'fr', label: 'Français', country: 'fr' },
  { code: 'es', label: 'Español', country: 'es' },
  { code: 'pt', label: 'Português', country: 'pt' },
  { code: 'de', label: 'Deutsch', country: 'de' },
  { code: 'zh', label: '中文', country: 'cn' },
  { code: 'ja', label: '日本語', country: 'jp' },
  { code: 'ko', label: '한국어', country: 'kr' },
  { code: 'ar', label: 'العربية', country: 'sa' },
  { code: 'sw', label: 'Kiswahili', country: 'ke' },
]

export const DEFAULT_LANGUAGE = 'en'

export function isRtl(code: string): boolean {
  return code === 'ar'
}
